export enum EmailFormCallerType {
  DashboardRequest,
  RfrAssignmentsRequest,
}
